import makeStyles from "@mui/styles/makeStyles";
import { CircleIconProps } from "./CircleIcon.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: CircleIconProps) => ({
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: 120,
    height: 120,
    background: props.bgColor || theme.palette.grey[100],
    borderRadius: 999,
    "&:before": {
      content: "''",
      position: "absolute",
      width: 80,
      height: 80,
      background: "#fff",
      borderRadius: 999,
    },
    "& > svg, > img": {
      position: "relative",
      width: 40,
      height: 40,
      color: props.iconColor ? theme.palette[props.iconColor].main : undefined,
    },
  }),
}));
